<template lang="pug">
    div.minutaContent(v-if='informacoesMinuta')
        div.linha
            div.coluna.centralizado
                b MINUTA DO TCA
        div.linha
            div.coluna.centralizado
                b TCA – TERMO DE COMPROMISSO DA ADEQUAÇÃO AMBIENTAL
        div.linha
        div.linha

        div.linha
            div.coluna
                b NÚMERO DO TCA: 
                span {{ informacoesMinuta.numeroTCA }}
        div.linha
            div.coluna
                b NÚMERO DO CAR: 
                span {{ informacoesMinuta.numeroCAR }}
        div.linha
            div.coluna
                b NÚMERO DO PAA: 
                span {{ informacoesMinuta.numeroPAA }}

        div.linha

        div.linha
            div.coluna
                | A(s) pessoa (s) física (s) ou jurídica (s), abaixo identificada (s), compromete(m)-se,
                | perante a Coordenadoria de Assistência Técnica Integral – CATI, a
                | executar as medidas descritas no presente Termo, com vistas à adequação
                | ambiental do imóvel rural de que trata este instrumento, sem a adesão ao Programa
                | de Regularização Ambiental – PRA, previsto na Lei federal nº 12.651, de 25 de maio de 2012.

        div.linha
        div.linha

        div.linha(
            v-if="informacoesMinuta.compromissarios.some(c => !c.representanteLegal)"
        )
            div.coluna
                b NOME E QUALIFICAÇÃO DOS COMPROMISSÁRIOS

        div(
            v-for="(compromissario, i) in informacoesMinuta.compromissarios"
            :key="'compromissario-' + i"
            v-if="!compromissario.representanteLegal"
        )
            div.linha
                div.coluna NOME DO COMPROMISSÁRIO(S): {{ compromissario.nome }}
            div.linha
                div.coluna CPF/CNPJ: {{ compromissario.cpf }}
            div.linha
                div.coluna Endereço: {{ compromissario.endereco }}
            div.linha
                div.coluna CEP: {{ compromissario.cep }}
            div.linha
                div.coluna Município/UF: {{ compromissario.municipio }}

        div.linha(
            v-if="informacoesMinuta.compromissarios.some(c => c.representanteLegal)"
        )
            div.coluna
                b NOME E QUALIFICAÇÃO DOS REPRESENTANTES LEGAIS

        div(
            v-for="(compromissario, i) in informacoesMinuta.compromissarios"
            :key="'representante-' + i"
            v-if="compromissario.representanteLegal"
        )
            div.linha
                div.coluna NOME DO REPRESENTANTE LEGAL: {{ compromissario.nome }}
            div.linha
                div.coluna CPF/CNPJ: {{ compromissario.cpf }}
            div.linha
                div.coluna Endereço: {{ compromissario.endereco }}
            div.linha
                div.coluna CEP: {{ compromissario.cep }}
            div.linha
                div.coluna Município/UF: {{ compromissario.municipio }}

        div.linha
            div.coluna
                b DADOS DO IMÓVEL

        div
            div.linha
                div.coluna Nome do Imóvel: {{ informacoesMinuta.imovel.nome }}
            div.linha
                div.coluna Tipo: {{ getTipoImovel(informacoesMinuta.imovel.tipo) }}
            div.linha
                div.coluna Município/UF: {{ informacoesMinuta.imovel.municipio.nome }}/{{ informacoesMinuta.imovel.municipio.codEstado }}
            div.linha(v-if='informacoesMinuta.imovel.cep')
                div.coluna CEP: {{ informacoesMinuta.imovel.cep }}
            div.linha
                div.coluna Módulos Fiscais: {{ informacoesMinuta.imovel.modulosFiscais }}
        div.linha
            div.coluna
                b Endereço Correspondência:
        div
            div.linha
                div.coluna Endereço: {{ informacoesMinuta.endereco.nomeLogradouro + ", n " + informacoesMinuta.endereco.numero }}
            div.linha
                div.coluna Bairro: {{ informacoesMinuta.endereco.bairro }}
            div.linha
                div.coluna CEP: {{ informacoesMinuta.endereco.cep }}
            div.linha
                div.coluna Município/UF: {{ informacoesMinuta.endereco.municipio.nome + "/" + informacoesMinuta.endereco.municipio.codEstado }}

        div.linha
            div.coluna
                | Os demais dados do imóvel objeto deste Termo estão especificados no Recibo do
                | CAR, que consta deste instrumento como Anexo I.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA I-DO OBJETO

        div.linha
            div.coluna
                | 1. O presente Termo tem por objeto a regularização ambiental do imóvel rural
                | indicado no campo “Dados do imóvel”, conforme o Projeto de Adequação Ambiental
                | – PAA que consta deste TCA como Anexo II, a ser executado nas áreas, na forma e
                | nos prazos nele especificados, e, quando houver, de acordo com as decisões
                | judiciais e os Termos de Compromisso anteriores não revistos referentes ao imóvel.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA II-COMPROMISSOS E DECISÕES JUDICIAIS ANTERIORES

        div.linha
            div.coluna
                | 1.Quando houver, os Termos de compromisso anteriores que não foram revistos
                | e/ou as decisões judiciais relacionados com a regularização do imóvel rural e cujas
                | cópias constarão como Anexo III integram o presente TCA, prevalecendo as
                | obrigações neles estabelecidas originalmente, com destaque para a forma de
                | cumprimento e prazos.
                p
                | 2. Repactuam-se, com a assinatura deste TCA, eventuais Termo(s) elencados no
                | Anexo I cuja revisão foi deferida, que são ora incorporado(s) e substituído(s) pelo
                | presente instrumento, passando-se a observar as regras estabelecidas no Projeto de
                | Adequação Ambiental – PAA.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA III-DAS OBRIGAÇÕES DO COMPROMISSÁRIO

        div.linha
            div.coluna
                | 1. O(s) compromissário(s) compromete(m)-se a:
                p
                | 1.1. adotar as medidas estabelecidas no PAA;
                p
                | 1.2 observar as regras contidas na Resolução Conjunta SAA/SMA nº 03, de 16 de
                | setembro de 2020, bem como no Manual Técnico Operacional, nos termos da
                | Resolução Conjunta SAA/SIMA nº 04, de 1º de outubro de 2021, alterada pela
                | Resolução Conjunta SAA/SIMA nº 05 de 22 de outubro de 2021, ou outra que vier a
                | substituí-la, que estabelecem critérios e diretrizes para a implantação, condução e
                | monitoramento da recomposição da vegetação;
                p
                | 1.3. monitorar periodicamente as áreas de recomposição da vegetação, conforme
                | estipulado no PAA;
                p
                | 1.4 adotar as providências necessárias para o alcance e a manutenção dos valores
                | de referência dos indicadores ecológicos de recomposição da vegetação, nos
                | termos da Resolução Conjunta SAA /SIMA nº 04, de 1º de outubro de 2021, alterada
                | pela Resolução Conjunta SAA/SIMA nº 05, de 22 de outubro de 2021, ou outra que
                | vier a substituí-la; e
                p
                | 1.5 apresentar relatórios de implantação das fases do PAA, assim como prestar
                | outras informações pertinentes, de acordo a Resolução Conjunta SAA/SMA nº 03,
                | de 16 de setembro de 2020 e o Manual Técnico Operacional, nos termos da
                | Resolução Conjunta SAA/SIMA nº 04, de 1º de 0utubro de 2021, alterada pela
                | Resolução Conjunta SAA/SIMA nº 05, de 22 de outubro de 2021, ou outra que vier a
                | substituí-la.
                p
                p
                | 2. Este TCA somente será considerado cumprido, no que diz respeito às obrigações
                | disciplinadas pela Resolução Conjunta SAA/SMA nº 03, de 16 de setembro de 2020,
                | após o alcance dos valores de referência finais dos indicadores ecológicos de
                | recomposição da vegetação, nos termos da Resolução Conjunta SAA/SIMA nº 04,
                | de 1º de outubro de 2021, alterada pela Resolução Conjunta SAA/SIMA nº 05, de 22
                | de outubro de 2021 ou outra que vier a substituí-la.
                p
                p
                | 3. O(s) compromissário(s) obriga(m)-se a respeitar as áreas protegidas e a preservar
                | a vegetação nativa existente no imóvel rural, cumprindo o disposto na Lei federal nº
                | 12.651, de 25 de maio de 2012, na Lei federal nº 11.428, de 22 de dezembro de
                | 2006, no Decreto federal nº 6.660, de 21 de novembro de 2008, e na Lei estadual nº
                | 13.550, de 02 de junho de 2009.
                p
                | 4. Na hipótese de haver no imóvel drenos ou valas, o(s) compromissário(s)
                | compromete(m)-se a adotar as medidas de manutenção e conservação de solo e
                | água e a comunicar a sua existência ao órgão estadual de recursos hídricos,
                | visando a sua regularização, mediante obtenção de dispensa ou outorga d'água da
                | captação ou derivação.
                p
                | 5. O(s) compromissário(s) deverá(ão) cumprir, quando houver, os Termos de
                | compromisso anteriores firmados que não foram revistos pelo presente TCA, assim
                | como as obrigações decorrentes das decisões judiciais relativas à regularização
                | ambiental do imóvel.
                p
                | 6. Eventuais obrigações previstas em Termo(s) no(s) qual(is) o(s) compromissário(s)
                | não figura(m) como parte, mas que estão em execução ou serão executadas no
                | imóvel objeto do presente instrumento e que integram este TCA, terão a sua
                | execução assumida pelo(s) compromissário(s) até o alcance dos valores de
                | referência finais dos indicadores ecológicos de recomposição da vegetação
                | previstos no Manual Técnico Operacional a que se refere o artigo 8º da Resolução
                | Conjunta SAA/SMA nº 03, de 16 de setembro de 2020, caso o terceiro subscritor
                | do(s) Termo (s) não cumpra suas obrigações ou tal(is) Termo(s) venha(m) a ser total
                | ou parcialmente extinto(s) antes do término da consecução do seu objeto. Na
                | hipótese de assunção da execução das obrigações pelo(s) compromissário(s), será
                | possível a adequação do cronograma original de execução previsto no(s) termo(s)
                | de que trata este item, limitada ao prazo de vigência deste TCA.
                p
                | 7. A quitação deste TCA dependerá do cumprimento, quando houver, dos Termos
                | de compromisso anteriores que não foram revistos e/ou das obrigações decorrentes
                | de decisões judiciais a que se refere a cláusula “Compromissos e decisões judiciais
                | anteriores”.
                p
                | 8. Caso a regularização da Reserva Legal seja efetivada mediante compensação,
                | o(s) mecanismo(s) utilizado(s) e a(s) área(s) onde ela será realizada serão indicados
                | no Anexo I.
                p
                | 9. Este Termo será considerado descumprido caso haja alguma irregularidade na
                | área destinada à compensação de Reserva Legal, na hipótese em que ela seja
                | regularizada desta forma, observando-se o previsto na cláusula “Do fornecimento de
                | informações incorretas e do descumprimento das obrigações constantes do presente Termo”.
                p
                | 10. Quando for utilizado mecanismo temporário de compensação de Reserva Legal
                | com vistas à sua regularização, o(s) compromissário(s) deverá(ão) apresentar nova
                | proposta de instituição de Reserva Legal no prazo de 06 (seis) meses antes do fim
                | da vigência do negócio jurídico utilizado e assim sucessivamente.
                p
                | 11.O(s) compromissário(s) se obriga(m) a inserir no CAR, como anexo, no prazo de
                | 6 (seis) meses a contar da assinatura deste Termo, a certidão da matrícula expedida
                | pelo Cartório de Registro de Imóveis competente com o registro da alienação ao
                | Poder Público da área localizada em Unidade de Conservação de domínio público
                | pendente de regularização fundiária, visando a demonstrar a efetivação da
                | regularização da Reserva Legal do imóvel, quando esse for o mecanismo de
                | compensação utilizado e a alienação ainda não tiver sido registrada na matrícula do
                | imóvel situado na Unidade de Conservação. O prazo previsto neste item poderá ser
                | prorrogado, desde que o(s) titular(es) do imóvel rural apresente(m) justificativas que
                | venham a ser aceitas pelo órgão incumbido da análise do CAR.
                p
                | 12. Será cancelada, total ou parcialmente, a compensação da Reserva Legal
                | realizada por meio da alienação ao Poder Público da(s) área(s) especificada(s) no(s)
                | Cadastro(s) Ambiental(is) Rural(is) – CAR(s) do(s) imóvel(is) inserido(s) em
                | Unidade(s) de Conservação e cujo(s) número está(ão) indicado(s) no Anexo I do
                | presente Termo, se, dentro do prazo de 10 anos a contar do registro da aludida
                | alienação na matrícula do imóvel, ocorrer evicção ou qualquer outro fato que afete a
                | | transferência da área ao Poder Público, com destaque para os casos em que a
                | alienação tiver sido efetuada por quem não era o legítimo titular do domínio da área,
                | hipótese em que o(s) compromissário(s) deverá(ão) regularizar o déficit de Reserva
                | Legal do imóvel no prazo estabelecido pelo órgão competente.
                p
                | 13. As obrigações decorrentes da revisão por motivos técnicos de Termos de
                | compromisso anteriores que foram firmados com a Administração pública estadual
                | para atender a determinações do Poder Judiciário ficam com seus efeitos suspensos
                | até eventual homologação judicial da repactuação, que deverá ser requerida pelo(s)
                | compromissário(s) ao juízo competente no prazo de 30 dias após a celebração do
                | presente TCA.
                p
                | 14. O compromissário declarou a intenção de exploração sustentável, nos termos do
                | artigo 10 combinado com o artigo 2º, inciso XVII, ambos da Resolução SMA nº 189,
                | de 20 de dezembro de 2018, e, durante a realização do Manejo da Vegetação de
                | Reflorestamento nas áreas de Reserva Legal, autorizado pela homologação
                | deste PAA, se obriga a alcançar e a manter os valores de referência dos indicadores
                | ecológicos de recomposição da vegetação previstos no Manual Técnico Operacional
                | a que se refere o artigo 8º da Resolução Conjunta SAA/SMA nº 03, de 16 de
                | setembro de 2020. A autorização de Manejo da Vegetação de Reflorestamento não
                | implica a autorização para a Exploração Seletiva de que trata o artigo 10, §1º, e
                | artigo 2º, inciso XII, ambos da Resolução SMA nº 189, de 20 de dezembro de 2018,
                | que deverá ser obtida em procedimento específico junto ao órgão estadual competente.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA IV- DA REVISÃO E DA RETIFICAÇÃO DO TCA

        div.linha
            div.coluna
                | 1. O presente Termo poderá ser retificado ou revisto nas seguintes hipóteses:
                p
                | 1.1.em comum acordo entre as partes, em razão de evolução tecnológica;
                p
                | 1.2. havendo motivos justificáveis, devidamente aceitos pelo órgão subscritor do TCA;
                p
                | 1.3. havendo incorreções ou omissões verificadas posteriormente pelo órgão responsável por seu acompanhamento.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA V-DA VIGÊNCIA

        div.linha
            div.coluna
                | 1. Este Termo vigorará pelo prazo máximo de 20 (vinte) anos a contar da data do
                | início da execução das obrigações previstas no PAA, salvo no que diz respeito
                | àquelas que constituam objeto de eventuais decisões judiciais e Termos de
                | compromisso anteriores não revistos, que observarão as regras neles estipuladas
                | originalmente.
                p
                | 1.1.A vigência e a eficácia do presente Termo estão condicionadas à sua inserção,
                | pelo (s) compromissário (s), em sistema informatizado específico, devidamente
                | assinado, dentro do prazo de 90 dias contados a partir de sua disponibilização pelo
                | órgão público para assinatura ou de prazo adicional concedido, conforme disposto na
                | legislação, salvo quando for assinado eletronicamente no próprio SICAR-SP,
                | hipótese em que ele gerará os seus efeitos de imediato.
                p
                | 2. Este TCA poderá ser considerado cumprido antes do prazo de 20 (vinte) anos,
                | desde que os valores de referência finais dos indicadores ecológicos de
                | recomposição da vegetação tenham sido atingidos, nos termos da Resolução
                | Conjunta SAA/SIMA nº 04, de 1º de outubro de 2021, alterada pela Resolução
                | Conjunta SAA/SIMA nº 05, de 15 de outubro de 2021, ou outra que vier a substituí-la.
                p
                | 3. Havendo motivo relevante e interesse das partes, o presente TCA poderá ter seu
                | prazo prorrogado, mediante alterações solicitadas pelo(s) compromissário(s) e
                | aprovadas pelo órgão competente

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA VI- DO FORNECIMENTO DE INFORMAÇÕES INCORRETAS E DO
                    | DESCUMPRIMENTO DAS OBRIGAÇÕES CONSTANTES DO PRESENTE TERMO

        div.linha
            div.coluna
                | 1. O descumprimento das obrigações previstas no presente Termo, com destaque
                | para as metas, compromissos e prazos intermediários e finais estabelecidos no
                | PAA, ou, quando solicitado, a ausência de retificação das informações incorretas ou
                | a não complementação daquelas faltantes, sem as devidas justificativas ou no caso
                | em que aquelas apresentadas não sejam aceitas pelo órgão público competente,
                | ensejará, conforme o caso:
                p
                | 1.1. a cobrança de multa moratória de 0,25 UFESP por dia para cada hectare no
                | qual forem descumpridas as obrigações de recomposição da vegetação, a contar da
                | data do descumprimento;
                p
                | 1.2. a imposição das sanções administrativas ambientais pertinentes, observando-se
                | a legislação aplicável;
                p
                | 1.3. a possível comunicação das irregularidades à autoridade policial pelo órgão que
                | lavrar Auto de Infração Ambiental, com vistas à apuração de eventual crime, em
                | especial aquele tipificado no artigo 68 da Lei federal nº 9.605, de 12 de fevereiro de 1998;
                p
                | 1.4. a suspensão ou o cancelamento do Cadastro Ambiental Rural – CAR do imóvel
                | objeto deste TCA;
                p
                | 1.5. a rescisão do TCA, na hipótese em que o Cadastro Ambiental Rural – CAR do
                | imóvel rural for cancelado;
                p
                | 1.6. a execução administrativa das obrigações de regularização ambiental do imóvel
                | rural, nos termos fixados pelos artigos 7º e 12 da Lei federal nº 12.651, de 25 de
                | maio de 2012, e das demais obrigações assumidas, após regular contraditório e ampla defesa;
                p
                | 1.7. a execução judicial do presente Termo pela Procuradoria Geral do Estado.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA VII– DO TÍTULO EXECUTIVO.

        div.linha
            div.coluna
                | Este Termo constitui título executivo extrajudicial, consoante o disposto no inciso II
                | do artigo 784 da Lei federal nº 13.105, de 16 de março de 2015, combinado com o
                | artigo 5º, § 6º, da Lei federal nº 7.347, de 24 de julho de 1985.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA VIII-DO FORO

        div.linha
            div.coluna
                | Fica eleito o foro da sede da Procuradoria Regional da Procuradoria Geral do Estado
                | de São Paulo cuja área de atuação abarque o local onde o imóvel rural de que trata
                | este Termo se situa, ou, se for o caso, o da Capital, para dirimir as questões
                | oriundas deste instrumento que não sejam resolvidas administrativamente pelas partes.
                p
                | Nada mais havendo, o presente termo é rubricado em todas as páginas, firmado e
                | inserido em sistema informatizado específico.
</template>

<script>
import { TipoImovelEnum } from '@/enums/imovel.enum.js';
export default {

    name: 'MinutaTCATextoComponent',

    props: {
        informacoesMinuta: {
            type: Object,
            required: true
        },
        isRepresentanteLegal: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
        }
    },
    methods: {
        getTipoImovel(idTipo) {
            return TipoImovelEnum[idTipo].nome;
        }
    }
}
</script>

<style lang="scss" scoped>
.minutaContent {
    padding: 10px;

    background-image: url("../../../assets/marca-dagua.jpg");

    .centralizado {
        display: flex;
        align-content: center;
        justify-content: center;
    }
}
</style>
